<!-- SPDX-License-Identifier: AGPL-3.0-or-later -->

<form class="form" [formGroup]="form" (ngSubmit)="_onSubmit()">
  <mat-form-field appearance="outline">
    <mat-label>Username</mat-label>
    <input
      matInput
      type="text"
      name="username"
      formControlName="username"
      aria-describedby="usernameHelp"
      min="3"
    />
    @if (form.controls.username?.errors?.required) {
      <mat-error>A username is required!</mat-error>
    } @else if (form.controls.username?.errors?.minlength) {
      <mat-error>Username must be at least 3 characters long!</mat-error>
    }
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Password</mat-label>
    <input matInput type="password" name="password" min="8" formControlName="password" />
    @if (form.controls.password?.errors?.required) {
      <mat-error>A password is required!</mat-error>
    } @else if (form.controls.password?.errors?.minlength) {
      <mat-error>Password must be at least 8 characters long!</mat-error>
    }
  </mat-form-field>
  <mat-form-field appearance="outline">
    <mat-label>Confirm password</mat-label>
    <input
      matInput
      type="password"
      name="passwordConfirm"
      min="8"
      formControlName="passwordConfirm"
    />
    @if (form.controls.passwordConfirm?.errors?.notMatching) {
      <mat-error>Passwords do not match!</mat-error>
    }
  </mat-form-field>
  <button data-cy="submit-button" type="submit" mat-flat-button color="primary">
    {{ submitText }}
  </button>
</form>
